export default "__VITE_PUBLIC_ASSET__43067999__"